// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1616":"67cbc7b689f32dae","6578":"fd5c6f6f3035cdfb"}[chunkId] + ".css";
};